import { useEffect } from 'react';

import type { SpaceAdapterRuntimeController } from '@/_contract/types';

export function useAdapterRuntimeTicks<
	TConfig,
	TRuntimeState,
	TCosmosData extends object,
>(args: {
	controller: SpaceAdapterRuntimeController<TConfig, TRuntimeState, TCosmosData>;
	intervalMs: number | undefined;
	isSuspended: () => boolean;
	onTick: (deltaMs: number) => void;
}) {
	const { controller, intervalMs, isSuspended, onTick } = args;
	useEffect(() => {
		if (!controller.reduceRuntimeTick) return;
		if (intervalMs === undefined || intervalMs <= 0) return;

		let previousNowMs = performance.now();
		const intervalId = window.setInterval(() => {
			if (isSuspended()) return;
			const nowMs = performance.now();
			const deltaMs = nowMs - previousNowMs;
			previousNowMs = nowMs;
			onTick(deltaMs);
		}, intervalMs);
		return () => window.clearInterval(intervalId);
	}, [controller, intervalMs, isSuspended, onTick]);
}
